var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "qty_adjuster" }, [
    _c(
      "button",
      {
        staticClass: "css_minus",
        attrs: { disabled: _vm.adjustDisabled(-1) },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.adjust(-1)
          },
        },
      },
      [_c("div", { staticClass: "sr-only" }, [_vm._v("Decrease quantity")])]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "qty_adjuster_number" }, [
      _c(
        "label",
        {
          staticClass: "qty_adjuster_label visually-hidden",
          attrs: { for: "quantity-input" },
        },
        [_vm._v("Quantity")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localVal,
            expression: "localVal",
          },
        ],
        attrs: {
          id: "quantity-input",
          type: "number",
          name: _vm.name,
          min: _vm.min,
          max: _vm.max,
          readonly: "",
          "aria-label": `Current quantity: ${_vm.localVal}`,
          "aria-live": "polite",
        },
        domProps: { value: _vm.localVal },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.localVal = $event.target.value
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "css_plus",
        attrs: { disabled: _vm.adjustDisabled(1) },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.adjust(1)
          },
        },
      },
      [_c("div", { staticClass: "sr-only" }, [_vm._v("Increase quantity")])]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }